import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const NavBar = ({ token, onLogout }) => {
  const [org, setOrg] = useState('Advance Trauma & Multispeciality Hospital');

  useEffect(() => {
    const storedOrg = token ? localStorage.getItem('org') : 'Advance Trauma & Multispeciality Hospital';
    setOrg(storedOrg || 'Advance Trauma & Multispeciality Hospital');
  }, [token]);

  const handleLogout = () => {
    // Clear localStorage and remove token
    localStorage.clear();
    onLogout(); // Call the passed onLogout function to update the app's state
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" fixed="top">
      <Navbar.Brand as={Link} to="/dashboard" className="text-nowrap overflow-hidden">
        {org}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ms-auto">
          {token ? (
            <>
              <NavDropdown title="Reports" id="reports-dropdown" align="end">
                <NavDropdown.Item as={Link} to="/receipts">Receipts</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/invoices">Invoices</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services">Services</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="Profile" id="profile-dropdown" align="end">
                <NavDropdown.Item as={Link} to="/change-password">Change Password</NavDropdown.Item>
                <NavDropdown.Item as="button" onClick={handleLogout}>Logout</NavDropdown.Item>
              </NavDropdown>
            </>
          ) : (
            <Nav.Link as={Link} to="/login">Login</Nav.Link>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

NavBar.propTypes = {
  token: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
};

export default NavBar;
